import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EmptyStateDashboard } from './emptyStateDashboard';
import { DashboardWidgetShell, DashboardWidgetSkeleton } from './widgets';
import { DashboardTabs } from './dashboardTabs';
import { AlertTabEnum, AlertTabs, formatExpiration } from './constants';
import { FindLoad } from 'utils';
import { dashboardActions } from 'store';

const ACTION_TYPE = 'GET_DASHBOARD_INSURANCE_ALERTS';

export const InsuranceAlertsCard = ({ item, handleDeleteWidget }) => {
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState(AlertTabEnum.EXPIRING);
    const { insuranceAlerts } = useSelector((state) => ({
        insuranceAlerts: state.dashboard.insuranceAlerts,
    }));
    const loader = FindLoad(ACTION_TYPE);
    const activeList = activeTab === AlertTabEnum.EXPIRING ? insuranceAlerts?.expiring : insuranceAlerts?.expired;
    const tabs = AlertTabs.map((tab) => ({
        ...tab,
        count: (tab.key === AlertTabEnum.EXPIRING ? insuranceAlerts?.expiring?.length : insuranceAlerts?.expired?.length) || 0,
    }));

    useEffect(() => {
        if (item?.apiPath) {
            dispatch(dashboardActions.getWidgetsData(ACTION_TYPE, item?.apiPath));
        }
    }, [item?.apiPath]);

    if (loader?.length) {
        return <DashboardWidgetSkeleton />;
    }

    return (
        <DashboardWidgetShell iconId={11} onClose={handleDeleteWidget}>
            <div className="dashboard-tabbed-body">
                <DashboardTabs activeKey={activeTab} onChange={setActiveTab} tabs={tabs} />

                <div className="main-dashboard-card-body">
                    {activeList?.length ? (
                        <div className={`dashboard-alert-list ${activeTab === AlertTabEnum.EXPIRED ? 'is-expired' : ''}`}>
                            {activeList.map((alert, index) => (
                                <div className="dashboard-alert-row" key={index}>
                                    <div className="dashboard-alert-row__body">
                                        {alert?.clientName && <p className="dashboard-alert-row__name">{alert?.clientName}</p>}
                                        <p className="dashboard-alert-row__sub">
                                            {alert?.payerName && <span className="dashboard-alert-row__type">{alert?.payerName}</span>}
                                            <span className="dashboard-alert-row__exp">
                                                {alert?.payerName ? ' - ' : ''}
                                                {formatExpiration(alert)}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <EmptyStateDashboard
                            iconId={11}
                            title={activeTab === AlertTabEnum.EXPIRING ? 'No expiring insurance' : 'No expired insurance'}
                            description={
                                activeTab === AlertTabEnum.EXPIRING ? (
                                    <p>
                                        All client payers are up to date. <br /> Nothing is due to expire soon.
                                    </p>
                                ) : (
                                    <p>
                                        All client payers are up to date. <br /> Continue tracking to stay compliant.
                                    </p>
                                )
                            }
                        />
                    )}
                </div>
            </div>
        </DashboardWidgetShell>
    );
};
